import { render, staticRenderFns } from "./HistoriesTab.vue?vue&type=template&id=feacef76&scoped=true&lang=pug"
import script from "./HistoriesTab.vue?vue&type=script&lang=ts"
export * from "./HistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./HistoriesTab.vue?vue&type=style&index=0&id=feacef76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feacef76",
  null
  
)

export default component.exports